module.exports = __webpack_public_path__ + "static/2006-header-a52626df071916d26155da0db00e1b7a.jpg";